import React, { useState } from 'react';
import Page from '../Page.js';
import PAGES from '../../data/PagesConstants.js';
import uiManager from '../../../config/ui.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import { getApi } from '../../api/endpoints.js';
import { useNavigate } from 'react-router-dom';
import FormPartial from './FormPartial.js';
import LeadsEarningConfig from '../../models/LeadsEarningConfig.js';
import { toast } from 'react-toastify';

const New = (props) => {
  const [leadsEarningConfig, setLeadsEarningConfig] = useState(new LeadsEarningConfig());
  const [createApi] = getApi('createLeadsEarningConfig')
  const navigate = useNavigate();

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      toast.success("Created Successfully");
      navigate(-1);
    } catch (error) {
      let leadsEarningConfigObj = new LeadsEarningConfig(leadsEarningConfig);
      leadsEarningConfigObj.set_api_errors(error.data.data.errors);
      if(error.data.message && error.data.message.trim() !== ""){
        toast.error(error.data.message);
      }
    }
  }

  const handleSubmitFunction = () => {
    try{
      createRecord(new LeadsEarningConfig(leadsEarningConfig).toApiJson());
    } catch (e) {
      setLeadsEarningConfig(new LeadsEarningConfig(leadsEarningConfig));
    }
  }

  const handleCancelFunction = () => {
    navigate(-1);
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.NewLeadsEarningConfigsPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Leads Earning Configuration", url: '/leads_earning_configs'}, { label: "New" }]}
    className={'leads-earning-configs-new-page'}
  >
    <PageContentWrapper contentHeading={"Create New Leads Earning Configuration"}>
      <div className='m-3'>
        <div className='mb-4 col-md-12'>
          <form className="row g-3" autoComplete="off">
            <FormPartial leadsEarningConfig={leadsEarningConfig} setLeadsEarningConfig={setLeadsEarningConfig} />
            <div className='mb-4 col-md-12'>
              <div >
                <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
                <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Create</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </PageContentWrapper>
  </Page>
}
export default New;